import React from 'react';
import { CheckCircle } from '@material-ui/icons';
import { GridCellParams } from '@material-ui/data-grid';

const CustomGridCellVipIcon = (params: GridCellParams) => {
  return <>{params.value === 1 ? <CheckCircle color='primary' /> : ''}</>;
};

export default CustomGridCellVipIcon;
